// extracted by mini-css-extract-plugin
export default {"tooltip":"dq3Li0_7yabF4BlxaqrQ","tooltipArrow":"pd34Utehqm1bG9dFiYtE","arrow":"dwJy8A_Xav4CCSb1Uy4X","text":"qEEfWilmpTmCy9jE_5e_"};